import { PERMISSIONS, ROUTE_PATHS } from "../../../PermissionsConstants";
import { AllOfficesStatus } from "./AllOfficesStatus";
import { AllOpenOffices } from "./AllOpenOffices";
import { BillsOfficeHierarchyReport } from "./BillsOfficeHierarchyReport";
import { DarkOffices } from "./DarkOffices";
import { OfficeHierarchyReport } from "./OfficeHierarchyReport";
import { OfficeHoursReport } from "./OfficeHoursReport";
import { SalesforceAllOffices } from "./SalesforceAllOffice";
import { SalesOperationsReport } from "./SalesOperationsReport";
import { SPLCOfficesReport } from "./SPLCOfficesReport";

export const OfficeSideBar = [
  {
    title: "All Open Office",
    to: ROUTE_PATHS.AllOpenOffices_Reports,
    component: AllOpenOffices,
    permission: PERMISSIONS.permission_report_office_allopenoffice_view,
  },
  {
    title: "Dark Offices",
    to: ROUTE_PATHS.DarkOffices_Reports,
    component: DarkOffices,
    permission: PERMISSIONS.permission_report_office_darkreports_view,
  },
  {
    title: "All Offices – All Status",
    to: ROUTE_PATHS.AllOfficesStatus_Reports,
    component: AllOfficesStatus,
    permission: PERMISSIONS.permission_report_office_allstatusoffice_view,
  },
  {
    title: "Office Hours",
    to: ROUTE_PATHS.OfficeHours_Reports,
    component: OfficeHoursReport,
    permission: PERMISSIONS.permission_report_office_officehours_view,
  },
  {
    title: "Office Hierarchy",
    to: ROUTE_PATHS.OfficeHierarchy_Reports,
    component: OfficeHierarchyReport,
    permission: PERMISSIONS.permission_report_office_officehierarchy_view,
  },
  {
    title: "Bill’s Office Hierarchy Report",
    to: ROUTE_PATHS.BillsOfficeHierarchy_Reports,
    component: BillsOfficeHierarchyReport,
    permission: PERMISSIONS.permission_report_office_billsofficehierarchy_view,
  },
  {
    title: "Sales Operations Report",
    to: ROUTE_PATHS.SalesOperations_Reports,
    component: SalesOperationsReport,
    permission: PERMISSIONS.permission_report_office_salesoperations_view,
  },
  {
    title: "SPLC Offices Report",
    to: ROUTE_PATHS.SPLCOffices_Reports,
    component: SPLCOfficesReport,
    permission: PERMISSIONS.permission_report_office_splcoffices_view,
  },
  {
    title: "Salesforce-ALL Report",
    to: ROUTE_PATHS.SalesforceAll_Reports,
    component: SalesforceAllOffices,
    permission: PERMISSIONS.permission_report_office_salesforceall_view,
  },
];
